import React, { useLayoutEffect, useEffect } from 'react';
import HeaderV3 from '../../../components/HeaderV3/headerV3.component';
import FooterSection from '../../../components/FooterSection/footersection.component';
import OrbixContact from '../../../components/ContactSection/contact.component';
import HeroSection from './oculo-components/HeroSection/HeroSection';
import WhatOculoChanges from './oculo-components/WhatOculoChanges/WhatOculoChanges';
import HowItWorks from './oculo-components/HowItWorks/HowItWorks';
import DigitalTwin from './oculo-components/DigitalTwin/DigitalTwin';
import AccuracySection from './oculo-components/AccuracySection/AccuracySection';
import PipelineSection from './oculo-components/PipelineSection/PipelineSection';
import BuiltForNDE from './oculo-components/BuiltForNDE/BuiltForNDE';
import AnalyticsSection from './oculo-components/AnalyticsSection/AnalyticsSection';
import ReportTypes from './oculo-components/ReportTypes/ReportTypes';
import FaqSection from './oculo-components/FaqSection/FaqSection';
import './oculo.component.css';

function OculoPage() {
  useLayoutEffect(() => {
    document.body.style.backgroundColor = '#0E0B1A';
    return () => { document.body.style.backgroundColor = ''; };
  }, []);

  useEffect(() => {
    const reveals = document.querySelectorAll('#oc-page .oc-reveal');
    const obs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('oc-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    reveals.forEach(el => {
      const siblings = el.parentElement ? Array.from(el.parentElement.querySelectorAll(':scope > .oc-reveal')) : [];
      const idx = siblings.indexOf(el);
      if (idx > 0) el.style.transitionDelay = (idx * 95) + 'ms';
      obs.observe(el);
    });
    return () => obs.disconnect();
  }, []);

  return (
    <main className="page-wrapper dark-mode">
      <HeaderV3 />
      <div id="oc-page">
        <HeroSection />
        <WhatOculoChanges />
        <HowItWorks />
        <DigitalTwin />
        <AccuracySection />
        <PipelineSection />
        <BuiltForNDE />
        <AnalyticsSection />
        <ReportTypes />
        <FaqSection />
      </div>
      <OrbixContact
        subheading="Contact us today."
        heading="Reach out to our team to book a demo or learn more."
      />
      <FooterSection />
    </main>
  );
}

export default OculoPage;
